export class ClientModel {
    id: any
    ownName: string = ''
    parentName: string = ''
    email: string = ''
    phone: string = ''
    superUser = 0
    town: string = 'Улаанбаатар'
    district: string = ''
    unit: string = ''
    street: string = ''
    /** The picked khoroo from the delivery area list; null = an address saved as free text (or none). */
    deliveryAreaId: number | null = null
    zipcode: string = ''
    savedProducts: any[] = []
    company: any
    active: boolean = false
    static role: string
}